import '../components/css components/circles.css';
import logisticscircle from "../images/logistics_circle.jpg";
import prcircle from "../images/pr_circle.jpg";
import hrcircle from "../images/hr_circle.jpg";
import mediacircle from "../images/media_circle.jpg";
import rdcircle from "../images/R&d_circle.jpg";
import React, { useEffect } from 'react';
import WOW from 'wowjs';

function Circles() {
  useEffect(() => {
    const wow = new WOW.WOW({
      live: false
    });
    wow.init();
  }, []);

  return (
    <div className='circles' id='circles'>
      <h2 className='title'>circles</h2>
      <div className='contain-cricles wow slideInLeft' data-wow-duration="1.1s" data-wow-delay=".4s">
        <div className='card'>
          <img src={logisticscircle} alt='logistics' />
          <h2>Logistics</h2>
          <p>The Logistics Circle plays a crucial role in representing the team at various events and ensuring a strong team presence They are responsible for managing the team's booth, showcasing  <a href='#logistics'>more..</a></p>
        </div>
        <div className='card'>
          <img src={prcircle} alt='PR' />
          <h2>PR&FR</h2>
          <p>The PR circle has a special role in representing the team, and here are their important tasks: They communicate with different activities, organizations, and important people <a href='#pr'>more..</a></p>
        </div>
        <div className='card'>
          <img src={hrcircle} alt='hr' />
          <h2>HR</h2>
          <p>Human Resources Circle is the first follower and represents the spirit of all team members. The tasks of the Circle are as follows: Raising team spirit and maintaining balance among <a href='#hr'>more..</a></p>
        </div>
        <div className='card'>
          <img src={rdcircle} alt='R&D' />
          <h2>R&D</h2>
          <p>The R&D circle within our team serves a dual purpose, addressing both internal and external aspects. Internally, it focuses on skill enhancement and professional <a href='#rd'>more..</a></p>
        </div>
        <div className='card'>
          <img src={mediacircle} alt='media' />
          <h2>Media</h2>
          <p>The Media Circle holds a significant responsibility in the team by overseeing the creation of essential designs for advertisements. Their diverse tasks encompass various <a href='#media'>more..</a></p>
        </div>
      </div>
    </div>
  );
}

export default Circles;
